import { NAMESPACE as GLOBAL_NAMESPACE } from '../../constants';
import constants from './constants';

const PREFIX = `${GLOBAL_NAMESPACE}/${constants.NAMESPACE}` as const;

const UPDATE_TEST_DETAILS = `${PREFIX}/UPDATE_TEST_DETAILS` as const;
const RESET_TEST_DETAILS = `${PREFIX}/RESET_TEST_DETAILS` as const;

export default {
  RESET_TEST_DETAILS,
  UPDATE_TEST_DETAILS,
};
